import React from "react";
import "./_club-header.scss";
import LeftIcon from '../../assets/icons/left.svg';
import {AppVersionForTenants, TenantAppVersionConfig} from "../../../constants/Config";

interface ClubHeaderPropTypes {
  buttonActionHandle: any
  clubLogo: string
  backButtonEnabled: boolean
  tenant?: string
}

const ClubHeader = (props: ClubHeaderPropTypes): JSX.Element => {
  return (
    <div className={`clubHeaderContainer ${props.tenant}` }>
      <div className={'backButtonWrapper'}>
        {props.tenant == 'nzc' && (
          <div className={`backButtonContainer ${props.backButtonEnabled ? '' : 'backButtonContainer--disabled'}`}
               onClick={props.buttonActionHandle}>
            <img src={LeftIcon} alt=">"/>
          </div>
        )}
        {props.tenant && AppVersionForTenants.v2.tenants.includes(props.tenant) && (
          <div className={`backButtonContainer`}
               onClick={props.buttonActionHandle}>
            <img src={TenantAppVersionConfig[props.tenant].icons.singleResultBackButton} alt="<-"/>
          </div>
        )}
      </div>
      {props.clubLogo && (
        <div className={'clubHeaderLogo'}>
          <img src={props.clubLogo} className={'clubLogoImage'} alt="logo"/>
        </div>
      )}
      <div className={'extraDiv'}></div>
    </div>
  )
}

export default ClubHeader;
